import { render, staticRenderFns } from "./GroupSummary.vue?vue&type=template&id=6c99f9e4&scoped=true"
import script from "./GroupSummary.vue?vue&type=script&lang=js"
export * from "./GroupSummary.vue?vue&type=script&lang=js"
import style0 from "./GroupSummary.vue?vue&type=style&index=0&id=6c99f9e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c99f9e4",
  null
  
)

export default component.exports